email: |
  kei18 [at] ieee.org / okumura.k [at] aist.go.jp
name:
  familyName:
    en: Okumura
    ja: 奥村
  firstName:
    en: Keisuke
    ja: 圭祐

pageDescription: |
  Researcher in AI and robotics, planning. Interested in controlling multiple moving agents.
pageKeywords: keisuke, okumura, kei18, 奥村, 圭祐, 奥村圭祐
